import firebase from '../../firebase/compat'
import { invalidateThemesCache } from './themesCache'

// Client-wrappers om de super-admin-gated schrijf-callables. Dit is de ENIGE
// schrijfroute: de Firestore-rule op QuestionInsights staat op `write: if false`.
//
// De regio staat er expliciet bij — de standaard `firebase.functions()` wijst
// naar us-central1 en vindt deze functies niet.
// AI-CONTEXT: See docs/pitfalls.md#api-firebase-v1-region-default
// AI-CONTEXT: See docs/features/intelligence-thema-eerst.md

const call = (name) => firebase.app().functions('europe-west1').httpsCallable(name)

// Elke schrijfactie verandert de tellingen per thema (inzichten, publicaties):
// de gedeelde themalijst is daarna verouderd.
const insight = (payload) => call('saveQuestionInsight')(payload).then((r) => { invalidateThemesCache(); return r.data })

/**
 * Een nieuw inzicht onder zijn thema — de server leidt het thema af uit
 * celtype en parameters en weigert een bevinding zonder thema. De cel wordt
 * server-side uitgerekend; rijen of tellingen meesturen heeft geen zin.
 * `practice` en `leadTime` zijn de praktijkkant uit een gemodereerde
 * praktijkbijdrage. Ze staan er alleen in als de aanroeper ze meestuurt: een
 * afnemer die alleen tekst opslaat laat ze ongemoeid, in plaats van ze leeg te
 * maken.
 *
 * @param {{id?: string, cellType?: string, params?: object, sections?: {what: string, why: string, how: string}, text?: string, generatedText?: string, practice?: Array<import('./insightPractice').PracticeRow>, leadTime?: string}} args
 */
export const saveInsightDraft = (args) => insight({ action: 'saveDraft', ...args })

/** @param {{id: string, sections?: {what: string, why: string, how: string}, text?: string, generatedText?: string, practice?: Array<import('./insightPractice').PracticeRow>, leadTime?: string}} args */
export const publishInsight = (args) => insight({ action: 'publish', ...args })

/** @param {{id: string}} args */
export const unpublishInsight = ({ id }) => insight({ action: 'unpublish', id })

/** @param {{id: string}} args */
export const rejectInsight = ({ id }) => insight({ action: 'reject', id })

/** @param {{id: string}} args */
export const deleteInsight = ({ id }) => insight({ action: 'delete', id })


/**
 * Eén celtype live uitrekenen — de preview in de editor.
 * @param {{cellType: string, params: object}} args
 * @returns {Promise<{cellType: string, cellVersion: number, render: string, params: object, output: object}>}
 */
export const runCell = ({ cellType, params }) =>
    call('runIntelligenceCell')({ cellType, params }).then((r) => r.data)

/**
 * De nachtelijke controle handmatig starten. `dryRun` rekent wel maar schrijft
 * niets.
 * @param {{dryRun?: boolean}} [args]
 */
export const runSweepNow = ({ dryRun = false } = {}) =>
    call('runIntelligenceSweepNow')({ dryRun }).then((r) => r.data)
